// extracted by mini-css-extract-plugin
export default {"box":"RemoveConstant_box__QDNOu","selectTitle":"RemoveConstant_selectTitle__oCjm0","title":"RemoveConstant_title__fBe0a","inputTitle":"RemoveConstant_inputTitle__6fUKn"};